import React, { FC, useRef, useState } from 'react'
import styles from './CalendarComponent.module.css'
import DatePicker from 'react-datepicker'
import { format } from 'date-fns'
import { Calendar } from '../DateCalendar/components/Calendar/Calendar'
import DropDown from '../DropDown/DropDown'

export type CalendarComponentPropsType = {
  startDateString: string
  finishDateString: string
  setStartDateString: (startDateString: string) => void
  setFinishDateString: (finishDateString: string) => void
  handleTimeStartChange: (time: any) => void
  handleTimeFinishChange: (time: any) => void
  openTime: boolean
  startDate?: boolean
  endDate?: boolean
  customInput: JSX.Element
  timeStart: Date | null
  timeFinish: Date | null
}

const CalendarComponent: FC<CalendarComponentPropsType> = ({
  setStartDateString,
  setFinishDateString,
  startDateString,
  finishDateString,
  timeStart,
  handleTimeStartChange,
  customInput,
  openTime,
  startDate,
  endDate,
  handleTimeFinishChange,
  timeFinish,
}) => {
  const [showStartCalendar, setShowStartCalendar] = useState(true)
  const [showFinishCalendar, setShowFinishCalendar] = useState(false)
  const dropdownTimeStartRef = useRef<HTMLDivElement>(null)

  const [selectedStartDate, setSelectedStartDate] = React.useState(new Date())
  const [selectedFinishDate, setSelectedFinishDate] = React.useState(new Date())

  const onCheckStartCalendar = () => {
    setShowStartCalendar(true)
    setShowFinishCalendar(false)
  }
  const onCheckFinishCalendar = () => {
    setShowFinishCalendar(true)
    setShowStartCalendar(false)
  }

  const onClearStartDate = () => {
    setStartDateString('')
    setSelectedStartDate(null as never)
  }
  const onClearFinishDate = () => {
    setFinishDateString('')
    setSelectedFinishDate(null as never)
  }

  const selectDates = (startDate: Date, endDate: Date, type: 'start' | 'end') => {
    if (type === 'start') {
      setSelectedStartDate(startDate)
      startDate ? setStartDateString(format(startDate, 'dd.MM.yyyy')) : setFinishDateString('')
    } else {
      setSelectedFinishDate(endDate)
      endDate ? setFinishDateString(format(endDate, 'dd.MM.yyyy')) : setFinishDateString('')
    }
  }

  return (
    <div className={styles.calendarComponent}>
      <div className={styles.calendarContainer}>
        <div className={styles.inputsBlock}></div>
        <div className={styles.calendarBlock}>
          <Calendar
            typeDate={startDate ? 'start' : 'end'}
            selectedEndDate={selectedFinishDate}
            selectedStartDate={selectedStartDate}
            selectDates={selectDates}
          />
        </div>
        <div className={styles.timeContainer}>
          <span className={styles.timeText}>{startDate ? 'Время начала' : 'Время окончания'}</span>
          <DatePicker
            showTimeSelect
            showTimeSelectOnly
            selected={startDate ? timeStart : timeFinish}
            onChange={startDate ? handleTimeStartChange : handleTimeFinishChange}
            timeFormat='HH:mm'
            dateFormat='HH:mm'
            timeIntervals={15}
            timeCaption='Time'
            customInput={customInput}
            placeholderText='Когда?'
            isClearable
          />
        </div>
      </div>
    </div>
  )
}

export default CalendarComponent
